/** Stable chapter addresses, shared by navigation and the validated content contract. */
export const bibleChapterKeys = [
  "builds",
  "runes",
  "abilities",
  "mechanics",
  "carry",
  "synergies",
] as const;

/** Whether a value names one of the chapters. */
export const isBibleChapterKey = (value: unknown): value is (typeof bibleChapterKeys)[number] =>
  (bibleChapterKeys as readonly unknown[]).includes(value);
